import React, {useContext} from "react";
import PropTypes from "prop-types";
import ProgressiveImg from "../ProgressiveImg";
import TgModal from "../TgModal";
import CaptionInput from "./CaptionInput";
import ShareLink from "./ShareLink";
import {CommunityContext} from "../../community/context";

/**
 * Share Photo Modal
 */
const SharePhotoModal = ({ sharePhoto, toggleShare, isShareOpen, fbAppId }) => {
  if (!isShareOpen) return null;

  const { caption, fullscreen, handle, id, thumbnail_large } = sharePhoto;
  const {
    actions: { sendAnalytics },
  } = useContext(CommunityContext);

  const afterOpenModal = () => {
    sendAnalytics("Photo Modal Viewed", {modal_type: 'share'});
  };

  return (
    <TgModal
      isOpen={isShareOpen}
      closeModal={toggleShare}
      afterOpenModal={afterOpenModal}
    >
      <div className="flex flex-col w-full mb-12">
        <div className="flex flex-col justify-center w-full">
          <h3 className="w-full mb-6 text-center text-tgnavy text-3xl">
            Share Your Photo With Friends
          </h3>
          <div className="mx-auto" style={{ maxWidth: "280px" }}>
            <ProgressiveImg fullsize={fullscreen} thumbnail={thumbnail_large} />
          </div>
          <CaptionInput photoId={id} prevCaption={caption} />
          <ShareLink
            fbAppId={fbAppId}
            handle={handle}
          />
        </div>
      </div>
    </TgModal>
  );
};

SharePhotoModal.propTypes = {
  sharePhoto: PropTypes.object.isRequired,
  toggleShare: PropTypes.func.isRequired,
  isShareOpen: PropTypes.bool.isRequired,
  fbAppId: PropTypes.string.isRequired,
};

export default SharePhotoModal;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/SharePhotoModal/index.jsx